import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8.01 18.02L2 12.01L8.01 6L9.425 7.414L4.825 12.014L9.425 16.614L8.011 18.02H8.01ZM15.989 18.02L14.576 16.607L19.176 12.007L14.576 7.407L15.99 6L22 12.01L15.99 18.02H15.989Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Code"
);
